import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.js';
import './App.css';
import { Provider } from 'react-redux';
import { applyMiddleware, compose, legacy_createStore as createStore } from 'redux';
import { ToastContainer } from 'react-toastify';
import reportWebVitals from './reportWebVitals.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import createSagaMiddleware from 'redux-saga';
import reducers from './store/reducers/index.js';
import sagas from './store/saga/index.js';
import './assets/css/add.css'
import './assets/css/button.css'
import './assets/css/footer.css'
import './assets/css/manager.css'
import './assets/css/managerlogin.css'
import './assets/css/managerrecommendation.css'
import './assets/css/mypage.css'
import './assets/css/tasks.css'
import './assets/css/message.css'
import './assets/css/agents.css'
import 'react-toastify/dist/ReactToastify.css';
import "react-datetime/css/react-datetime.css";
const root = ReactDOM.createRoot(document.getElementById('root'));

// const composeEnhancers = compose;
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const sagaMiddleware = createSagaMiddleware();
const store = createStore(reducers, composeEnhancers(applyMiddleware(sagaMiddleware)));
sagaMiddleware.run(sagas);
root.render(
    <Provider store={store}>
        <App />
        <ToastContainer autoClose={1000} />
    </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
